import Texts_DE from "./Texts_DE";
import Texts_EN from "./Texts_EN";
import Texts_MIX from "./Texts_MIX";

const selectedLanguage = process.env.NEXT_PUBLIC_LANGUAGE;
console.log(process.env.NEXT_PUBLIC_LANGUAGE);
console.log("Selected language:", selectedLanguage);

const Texts =
    selectedLanguage === "en"
        ? Texts_EN
        : selectedLanguage === "mix"
            ? Texts_MIX
            : Texts_DE;

export default Texts;
